import React from 'react';

interface CreaturePlaceholderProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const CreaturePlaceholder: React.FC<CreaturePlaceholderProps> = ({
  className = '',
  size = 'md',
}) => {
  const sizeClasses = {
    sm: 'w-32 h-32',
    md: 'w-48 h-48',
    lg: 'w-64 h-64',
  };

  return (
    <div className={`flex flex-col items-center justify-center ${sizeClasses[size]} ${className}`}>
      {/* 古代生物のシルエットSVG */}
      <svg
        viewBox="0 0 200 200"
        className="w-full h-full text-gray-300 fill-current"
        aria-label="古代生物のシルエット"
      >
        {/* 体のシルエット（魚のような形） */}
        <ellipse cx="100" cy="100" rx="60" ry="30" />

        {/* 尾びれ */}
        <path d="M 160 100 Q 180 80 190 100 Q 180 120 160 100 Z" />

        {/* 頭部 */}
        <ellipse cx="70" cy="100" rx="25" ry="20" />

        {/* 目 */}
        <circle cx="65" cy="95" r="3" className="text-gray-400" />

        {/* 背びれ */}
        <path d="M 100 70 Q 120 50 140 70 Q 120 90 100 70 Z" />

        {/* 腹びれ */}
        <path d="M 100 130 Q 120 150 140 130 Q 120 110 100 130 Z" />

        {/* 側線（装飾的な線） */}
        <path d="M 80 100 Q 100 98 120 100" stroke="currentColor" strokeWidth="1" fill="none" />
        <path d="M 80 105 Q 100 103 120 105" stroke="currentColor" strokeWidth="1" fill="none" />
      </svg>

      {/* 調査中テキスト */}
      <div className="mt-4 text-center">
        <p className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
          調査中
        </p>
      </div>
    </div>
  );
};

export default CreaturePlaceholder;
